<!-- 库位显示组件 -->
<template> 
    <div>
        <div class="location_box location_color_green">
            <div class="location_title">1-A</div>
            <div class="location_text">货物：橡胶111</div>
            <div class="location_text">容量：2000吨</div>
            <div class="location_text">占用比例：20%</div>
        </div>
        <div class="location_box location_color_yellow">
            <div class="location_title">1-A</div>
            <div class="location_text">货物：橡胶111</div>
            <div class="location_text">容量：2000吨</div>
            <div class="location_text">占用比例：20%</div>
        </div>
        <div class="location_box location_color_red">
            <div class="location_title">1-A</div>
            <div class="location_text">货物：橡胶111</div>
            <div class="location_text">容量：2000吨</div>
            <div class="location_text">占用比例：20%</div>
        </div>
    </div>
</template>
<script>

    export default {
        name: '',
        props: {
            locationText: {
                type: Object,
                default: () => {}
            },
        },
        data() {
            return {}
        },
        watch: {

        },
        methods: {
        
        }
    }
</script>
<style lang="less" scoped>
.location_color_green{
    background-color: #E8F6E9;
    border-top: 5px solid #67C23A;
}
.location_color_yellow{
    background-color: #ffe6c0;
    border-top: 5px solid #E6A23C;
}
.location_color_red{
    background-color: #ffd1d1;
    border-top: 5px solid #F56C6C;
}
.location_box{
    width: 115px;
    height: 135px;
    border-radius: 10px;
    padding: 15px;
    margin: 5px;
}
.location_title{
    font-size: 26px;
    color: #2D8CF0;
    margin-bottom: 15px;
}
.location_text{
    font-size: 14px;
    color: #2D8CF0;
    margin-bottom: 5px;
}
</style>